import { Winder, createWinder, editWinder, presetInfo } from "./dataTypes";
import { BASE_URL, httpRequest } from "./api-shared";

const WINDER_URL = "winder";
const PRESET_URL = "preset";
export const getAllWindersApi = (): Promise<Winder[]> => {
    return httpRequest(`${BASE_URL}/${WINDER_URL}`,
      'get'
    ).then(result => {
      if (result.success) {
        return result.data as Winder[];
      } else {
        console.log("Error getting winders, " + result.error!.message);
        throw (result.error);
      }
    });
  }

 
  export const addWinderApi = (Winder:createWinder): Promise<Winder> => {
    return httpRequest(`${BASE_URL}/${WINDER_URL}`,
      'post', Winder
    ).then(res => {
      if (res.success === true && res.data) {
        return res.data as Winder;
      } else {
        console.log("Error adding winder, " + res.error!.message);
        throw (res.error);
      }
    });
  }

  export const editWinderApi = (winder:editWinder): Promise<Winder> => {
    return httpRequest(`${BASE_URL}/${WINDER_URL}`,
      'put', winder
    ).then(result => {
      if (result.success) {
        return result.data as Winder;
      } else {
        console.log("Error updating winder, " + result.error!.message);
        throw (result.error);
      }
    });
  };

  export const getAllPresetsApi = (): Promise<presetInfo[]> => {
    return httpRequest(`${BASE_URL}/${WINDER_URL}/${PRESET_URL}`,
      'get'
    ).then(result => {
      if (result.success) {
        return result.data as presetInfo[];
      } else {
        console.log("Error getting presets, " + result.error!.message);
        throw (result.error);
      }
    });
  }

  export const editPresetApi = (preset:presetInfo): Promise<presetInfo> => {
    return httpRequest(`${BASE_URL}/${WINDER_URL}/${PRESET_URL}`,
      'put', preset
    ).then(result => {
      if (result.success) {
        return result.data as presetInfo;
      } else {
        console.log("Error updating preset, " + result.error!.message);
        throw (result.error);
      }
    });
  };
  